import { render } from "./AddEnergySite.vue?vue&type=template&id=2446ea20"
import script from "./AddEnergySite.vue?vue&type=script&lang=js"
export * from "./AddEnergySite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__